var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('surveys-table',{attrs:{"surveyName":"CDLQI","surveyCode":"CDLQI","permission":{
      createSurvey: _vm.permissions.CREATE_SURVEY_CDLQI,
      viewDetail: _vm.permissions.SEE_DETAIL_SURVEY_CDLQI,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }